import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");
  const _component_MobileHeader = _resolveComponent("MobileHeader");
  const _component_el_header = _resolveComponent("el-header");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_PageFooter = _resolveComponent("PageFooter");
  const _component_MobilePageFooter = _resolveComponent("MobilePageFooter");
  const _component_el_footer = _resolveComponent("el-footer");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      height: "180",
      class: "header"
    }, {
      default: _withCtx(() => [_createVNode(_component_Header, {
        class: "pc-header",
        data: _ctx.navData
      }, null, 8, ["data"]), _createVNode(_component_MobileHeader, {
        class: "mobile-header",
        data: _ctx.navData
      }, null, 8, ["data"])]),
      _: 1
    }), _createVNode(_component_el_main, {
      class: "router-view"
    }, {
      default: _withCtx(() => [_createVNode(_component_router_view)]),
      _: 1
    }), _createVNode(_component_el_footer, {
      class: "footer",
      height: "990"
    }, {
      default: _withCtx(() => [_createVNode(_component_PageFooter, {
        class: "pc-footer"
      }), _createVNode(_component_MobilePageFooter, {
        class: "mobile-footer"
      })]),
      _: 1
    })]),
    _: 1
  });
}